import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMinisiteLayout } from '../../../contexts/MinisiteLayoutContext';
import language from '../../../utils/LanguageSettings';
import StbMax from '../MyAccount/component/Max/StbMax';

/**
 * Standalone STB HBO Max page wrapper
 * Bypasses login checking and directly instantiates StbMax with token.
 */
const StbHboMaxPage: React.FC = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token') || '';
    const { setLayout, resetLayout } = useMinisiteLayout();

    useEffect(() => {
        // Set layout mode for stb-hbomax standalone page
        setLayout('logo-language', 'footer-only');
        return () => {
            resetLayout();
        };
    }, [setLayout, resetLayout]);

    const currentLang: 'en' | 'zh' = language === 'zh' ? 'zh' : 'en';

    return <StbMax currentLang={currentLang} token={token} />;
};

export default StbHboMaxPage;
